export default () =>
Date.now().toString(36) + Math.random().toString(36).substr(2, 9)



// WEBPACK FOOTER //
// ./src/utils/IdGenerator.js